export const fdiDetailData = {
  headline: {
    total2024: 11.9,
    yoyChange: 53.6,
    q1: 2.45,
    q2: 2.78,
    q3: 2.80,
    q4: 3.87,
    target2025: 42,
    cumulative5yr: 25.6,
    fdiToGDP: 11.3,
    fdiPerCapita: 321,
  },

  history: [
    { year: '2019', value: 2.3, yoy: 15.0 },
    { year: '2020', value: 1.7, yoy: -26.1 },
    { year: '2021', value: 2.3, yoy: 35.3 },
    { year: '2022', value: 2.5, yoy: 8.7 },
    { year: '2023', value: 7.2, yoy: 188.0 },
    { year: '2024', value: 11.9, yoy: 65.3 },
    { year: '2025E', value: 15.0, yoy: 26.1, forecast: true },
  ],

  quarterly: [
    { q: 'Q1 23', value: 1.2 },
    { q: 'Q2 23', value: 1.6 },
    { q: 'Q3 23', value: 1.9 },
    { q: 'Q4 23', value: 2.5 },
    { q: 'Q1 24', value: 2.45 },
    { q: 'Q2 24', value: 2.78 },
    { q: 'Q3 24', value: 2.80 },
    { q: 'Q4 24', value: 3.87 },
  ],

  sourceCountries: [
    { country: 'China', code: 'CHN', value: 3.05, share: 25.6, yoy: 42.0, flag: '🇨🇳' },
    { country: 'Russia', code: 'RUS', value: 1.59, share: 13.4, yoy: 28.5, flag: '🇷🇺' },
    { country: 'Saudi Arabia', code: 'SAU', value: 0.94, share: 7.9, yoy: 156.0, flag: '🇸🇦' },
    { country: 'Turkey', code: 'TUR', value: 0.76, share: 6.4, yoy: 35.2, flag: '🇹🇷' },
    { country: 'UAE', code: 'ARE', value: 0.69, share: 5.8, yoy: 48.3, flag: '🇦🇪' },
    { country: 'Germany', code: 'DEU', value: 0.51, share: 4.3, yoy: 22.1, flag: '🇩🇪' },
    { country: 'South Korea', code: 'KOR', value: 0.48, share: 4.0, yoy: 85.0, flag: '🇰🇷' },
    { country: 'USA', code: 'USA', value: 0.42, share: 3.5, yoy: 62.0, flag: '🇺🇸' },
    { country: 'Japan', code: 'JPN', value: 0.38, share: 3.2, yoy: 44.0, flag: '🇯🇵' },
    { country: 'UK', code: 'GBR', value: 0.32, share: 2.7, yoy: 18.5, flag: '🇬🇧' },
  ],

  sectors: [
    { sector: 'Energy & Mining', value: 3.21, share: 27.0, projects: 45, yoy: 38.5 },
    { sector: 'Manufacturing', value: 2.62, share: 22.0, projects: 128, yoy: 52.0 },
    { sector: 'Financial Services', value: 1.43, share: 12.0, projects: 24, yoy: 85.0 },
    { sector: 'Telecoms & IT', value: 1.19, share: 10.0, projects: 67, yoy: 120.0 },
    { sector: 'Infrastructure', value: 1.07, share: 9.0, projects: 32, yoy: 45.0 },
    { sector: 'Agriculture', value: 0.83, share: 7.0, projects: 89, yoy: 28.0 },
    { sector: 'Real Estate', value: 0.71, share: 6.0, projects: 41, yoy: 35.0 },
    { sector: 'Other', value: 0.84, share: 7.0, projects: 156, yoy: 22.0 },
  ],

  topInvestors: [
    { company: 'CNPC', country: 'CHN', sector: 'Energy', invested: 1.2, status: 'ACTIVE', type: 'SOE' },
    { company: 'Masdar', country: 'ARE', sector: 'Renewables', invested: 0.8, status: 'ACTIVE', type: 'SOE' },
    { company: 'ACWA Power', country: 'SAU', sector: 'Energy', invested: 0.7, status: 'ACTIVE', type: 'PRIVATE' },
    { company: 'Veon', country: 'NLD', sector: 'Telecoms', invested: 0.5, status: 'ACTIVE', type: 'PUBLIC' },
    { company: 'Lukoil', country: 'RUS', sector: 'Energy', invested: 0.45, status: 'ACTIVE', type: 'PUBLIC' },
    { company: 'KIA Motors', country: 'KOR', sector: 'Auto', invested: 0.3, status: 'EXPANSION', type: 'PUBLIC' },
    { company: 'Siemens', country: 'DEU', sector: 'Industrial', invested: 0.25, status: 'ACTIVE', type: 'PUBLIC' },
    { company: 'Air Products', country: 'USA', sector: 'Chemicals', invested: 0.22, status: 'NEW', type: 'PUBLIC' },
  ],

  // Central Asia & Silk Road regional comparison
  regionalComparison: [
    { country: 'UZB', fdi2024: 11.9, fdiGDP: 11.3, growth: 53.6, perCapita: 321, rank: 1 },
    { country: 'KAZ', fdi2024: 28.0, fdiGDP: 11.8, growth: 12.5, perCapita: 1421, rank: 2 },
    { country: 'AZE', fdi2024: 4.5, fdiGDP: 5.8, growth: 15.0, perCapita: 441, rank: 3 },
    { country: 'GEO', fdi2024: 2.1, fdiGDP: 9.8, growth: 22.0, perCapita: 568, rank: 4 },
    { country: 'MNG', fdi2024: 2.8, fdiGDP: 15.2, growth: 18.0, perCapita: 824, rank: 5 },
    { country: 'TKM', fdi2024: 1.8, fdiGDP: 3.0, growth: 5.0, perCapita: 281, rank: 6 },
    { country: 'KGZ', fdi2024: 0.4, fdiGDP: 3.8, growth: 12.0, perCapita: 57, rank: 7 },
    { country: 'TJK', fdi2024: 0.25, fdiGDP: 2.2, growth: 8.5, perCapita: 25, rank: 8 },
  ],

  pipeline: [
    { project: 'Navoi Solar Plant', investor: 'Masdar (UAE)', sector: 'Renewables', value: 1.5, status: 'ANNOUNCED', year: 2025 },
    { project: 'Tashkent Automotive', investor: 'KIA (KOR)', sector: 'Manufacturing', value: 0.8, status: 'CONSTRUCTION', year: 2025 },
    { project: 'Fergana Textile Complex', investor: 'Indorama (SGP)', sector: 'Manufacturing', value: 0.6, status: 'PLANNING', year: 2026 },
    { project: 'Digital Bank License', investor: 'TBC (GEO)', sector: 'Fintech', value: 0.3, status: 'APPROVED', year: 2025 },
    { project: 'Bukhara Gas Processing', investor: 'Lukoil (RUS)', sector: 'Energy', value: 2.2, status: 'NEGOTIATION', year: 2026 },
    { project: 'Logistics Hub Tashkent', investor: 'DP World (ARE)', sector: 'Infrastructure', value: 0.5, status: 'MOU SIGNED', year: 2025 },
    { project: 'Pharma Manufacturing', investor: 'Stada (DEU)', sector: 'Healthcare', value: 0.2, status: 'ANNOUNCED', year: 2025 },
    { project: 'Data Center Tashkent', investor: 'Yandex (RUS)', sector: 'Tech', value: 0.15, status: 'PLANNING', year: 2026 },
  ],

  keyMetrics: {
    totalProjects: 582,
    newProjects2024: 187,
    jobsCreated: 45000,
    avgProjectSize: 20.4,
    greenfield: 68,
    ma: 32,
  },
};
